import { Tooltip } from '@bst/react-ui';
import { useTranslation } from "react-i18next";

/**
 * App Selector Button
 */
export const AppSelectorButton = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="global-utilities__item u-hide-sm-down app-settings-menu-btn">
        <Tooltip content={t("appSelector")}>
          <button
            className="global-utilities__button global-utilities__button--highlight"
            id="global-utilities__apps"
            tabIndex={-1}
            aria-label="Apps"
            aria-haspopup="true"
            aria-expanded="false"
            data-automation-id="global-utilities__apps"
          >
            <span
              className="global-utilities__button__icon"
              aria-hidden="true"
            >
              <i className="icon icon-all-apps"></i>
            </span>
          </button>
        </Tooltip>
      </div>
    </>
  );
};
